import * as formik from 'formik';
import * as yup from 'yup';
import { useState, useEffect } from 'react';
import FileDropArea from '../FileDropArea'
import { Modal, Button, Table, Form, InputGroup, Row, Col } from 'react-bootstrap';
import { getEntityDocumentLogo, editEntityDocumentLogo, getEntityDocumentLogoUrl } from '../../utils/api';
import Loader from '../Loader';
import { bytesToBase64 } from '../../utils/helpers';
import Success from '../Success';
import Error from '../Error';
import { useDataStore } from '../../Store';

const EditEntityDocumentSettingsModal = ({ show, onHide, entity }) => {

    const selectedEntity = useDataStore((state) => state.selectedEntity);

    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [isSaving, setIsSaving] = useState(false);
    const [isSaved, setIsSaved] = useState(false);

    const [filename, setFilename] = useState(null);
    const [fileType, setFileType] = useState(null);
    const [bytes, setBytes] = useState(null);

    const fetchData = async () => {
        setLoading(true);
        setError(null);

        const data = await getEntityDocumentLogo(entity.Id);
        if (data) {
            var logoUrl = await getEntityDocumentLogoUrl(entity.Id, true)
            setData(logoUrl);
        }
        else {
            setData(null);
        }
        setLoading(false);
    };

    const reset = () => {
        setBytes(null);
        setFileType(null);
        setFilename(null);
        setError(null);
        setLoading(false);
    };

    useEffect(() => {
        const onLoad = () => {
            if (show)
                fetchData();
            else
                reset();
        }
        onLoad();
    }, [show]);

    const uploadTitle = async (filename, fileType, bytes) => {
        setFilename(filename);
        setFileType(fileType);
        setBytes(bytes);
    }

    const closeModal = (shouldRefresh) => {
        setLoading(false);
        setIsSaving(false);
        setError(null);
        setIsSaved(false);
        onHide(shouldRefresh);
    }

    const removeLogo = () => {
        setFilename(null);
        setFileType(null);
        setBytes(null);
        setData(bytes);
    }

    const { Formik } = formik;
    const schema = yup.object().shape({

    });

    return (
        <>
            <Modal show={show} onHide={onHide} size="xl" style={{ zIndex: 1051 }} dialogClassName="modal-90w modal-content-1" backdropClassName="modal-backdrop-1" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Document Logo</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {loading || isSaving ? <Loader /> : error ? <Error /> : isSaved ? (
                        <div style={{ height: 230, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <Success />
                        </div>
                    ) : (
                        <Formik
                            validationSchema={schema}
                            onSubmit={async (form) => {

                                if (!filename) return;
                                if (!bytes) return;
                                if (!fileType) return;

                                setLoading(true);
                                setError(false);

                                const data = await editEntityDocumentLogo(entity.Id, filename, bytes, fileType);
                                const success = data?.Success ?? false;
                                if (success) {
                                    setIsSaved(true);
                                }
                                else {
                                    setError("an error occured")
                                }

                                setIsSaving(false);
                                setLoading(false);

                                if (success)
                                    setTimeout(() => closeModal(true), 2000);
                            }}
                            initialValues={{

                            }}
                        >
                            {({ handleSubmit, handleChange, values, touched, errors }) => (


                                <Form noValidate onSubmit={handleSubmit}>
                                    <div style={{ padding: 10, textAlign: 'center' }}>
                                        {bytes ? (
                                            <img src={`data:image/jpg;base64,${bytesToBase64(bytes)}`} alt="Document Logo" style={{ maxWidth: 180, width: 'auto', height: 84 }} />
                                        ) : data ? (
                                            <img src={data} alt="Document Logo" style={{ maxWidth: 180, width: 'auto', height: 84 }} />
                                        ) : (
                                            <>
                                                <FileDropArea isImage={true} style={{ minHeight: 250 }} onFileSelected={uploadTitle} footerText='Recommended: 534px × 94px png file' />
                                            </>
                                        )}
                                    </div>

                                    <br />

                                    <Row>
                                        <Col className="d-flex justify-content-start">
                                            <Button variant='danger' onClick={removeLogo} className="me-2">
                                                Remove Logo
                                            </Button>
                                        </Col>
                                        <Col className="d-flex justify-content-end">
                                            <Button type="submit">Save</Button>
                                        </Col>
                                    </Row>


                                </Form>

                            )}
                        </Formik>
                    )}

                </Modal.Body>
            </Modal >
        </>
    );
};

export default EditEntityDocumentSettingsModal;